import Component from './component';

const CardCarousel = (props) => <Component {...props} />;

export default CardCarousel;

export { Component as component };
